/** Presentation hints only; call after the admin API authorizes the document. */
export function readEmbedContext(search: string) {
  const params = new URLSearchParams(search);
  const embedded = params.get('osEmbed') === '1';
  const value = params.get('osTheme');
  return { embedded, theme: embedded && (value === 'light' || value === 'dark') ? value : undefined } as const;
}
export const embedContext = readEmbedContext(typeof location === 'undefined' ? '' : location.search);
export function adminEntry(id: string, search: string) {
  return `/admin/callsheets/${encodeURIComponent(id)}/overview${search}`;
}
export function resolveOsView(meta: { slug: string; status: string }, pathname: string, search: string) {
  const params = new URLSearchParams(search);
  if (!params.has('osView')) return null;
  const view = params.get('osView');
  params.delete('osView');
  let destination = pathname;
  let notice = '';
  if (view === 'full' || view === 'shoot') {
    if (meta.status !== 'published') notice = 'Publish this document before opening its public view. Your draft is still editable.';
    else {
      destination = `/${view === 'full' ? 'c' : 'shoot'}/${encodeURIComponent(meta.slug)}`;
      if (view === 'full') { params.set('fullview', '1'); params.set('as', 'full'); }
    }
  }
  const query = params.toString();
  return { to: destination + (query ? `?${query}` : ''), notice };
}
